import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Checkbox, Typography, Icon } from 'foundations-library/components'
import { IconNameType } from 'foundations-library/types'
import { getRemoteValue } from './../../utils'
import { DeviceInterface } from 'providers'

const jss = (theme) => {
    const { colors } = theme['foundations-library']
    return {
        root: {
            width: '100%',
            '& [data-testid$=device-checkbox-label], & [data-testid=device-container]': {
                width: '100%',
                display: 'flex',
                height: '80px',
                paddingLeft: '15px',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch',
                background: 'rgba(242, 241, 241, 0.70)',
                boxShadow: '0px -1px 0px 0px rgba(133, 146, 154, 0.20) inset'
            }
        },
        info: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            flex: '1 0 0',
            '& .name': {
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px',
                alignSelf: 'stretch',
                '& .this-device-badge': {
                    display: 'flex',
                    padding: '0px 8px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '10px',
                    borderRadius: '5px',
                    background: colors.neutral[100]
                }
            },
            '& .location-date': {
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                alignSelf: 'stretch'
            }
        }
    }
}

const useStyles = makeStyles(jss)

/**
 *
 */
export const Item = ({ device: { id, name, currentDevice, location, date, type } }: { device: DeviceInterface }): JSX.Element => {
    const classes = useStyles()

    return (
        <>
            <Icon name={icons[type]} color={'neutral-700'} size={30} />
            <div className={classes.info}>
                <div className='name'>
                    <Typography variant='subtitle2'>{name}</Typography>
                    {currentDevice && <div className='this-device-badge'>
                        <Typography variant='subtitle2' color='neutral-700'>{texts.currentDeviceBadge}</Typography>
                    </div>}
                </div>
                <div className='location-date'>
                    <Typography variant='subtitle3' color='neutral-700'>{location}</Typography>
                    <Typography variant='body3' color='neutral-500'>{date}</Typography>
                </div>
            </div>
        </>
    )
}

type PropsType = {
    device: DeviceInterface
    showCheckbox?: boolean
    shouldCurrentDeviceBeChecked?: boolean
    isChecked?: boolean
    handleCheck?: (id: number, isChecked: boolean) => void
}

type DeviceType = 'Desktop' | 'Mobile'

const icons: Record<DeviceType, IconNameType> = {
    Desktop: 'conference',
    Mobile: 'phone'
    // android: 'phone',
    // ios: 'phone-alt'
}

const texts = getRemoteValue('active_sessions')

/**
 *
 */
const Device = ({ device, showCheckbox = false, shouldCurrentDeviceBeChecked = false, handleCheck, isChecked }: PropsType): JSX.Element => {
    const classes = useStyles()

    let content = <></>
    if (showCheckbox) {
        const currentDeviceBeChecked = shouldCurrentDeviceBeChecked && device.currentDevice
        content = (
            <Checkbox
                checked={isChecked || currentDeviceBeChecked}
                disabled={currentDeviceBeChecked}
                onChange={handleCheck?.bind(this, device.id)}
                data-testid={`${device.id}-device-checkbox`}
            >
                <Item device={device} />
            </Checkbox>
        )
    } else {
        content = <div data-testid='device-container'><Item device={device} /></div>
    }

    return <div className={classes.root}>
        {content}
    </div>
}

export default Device
